/**
 * Why the sign-in page is showing, said to someone who followed a link they
 * were sent. A signed-out friend opening a campaign invitation or a table
 * address landed on a bare "Log in" form with no word about the invitation,
 * and a first-time visitor had no reason to think it was still there. Read
 * from the way back (`location.state.from`), so sign-up, reached from the
 * login page with the same `from`, says it too.
 */
export function signInReason(from) {
  if (typeof from !== 'string') return null;
  if (from.startsWith('/share/')) {
    return 'Log in, or sign up if you are new here, to open the invitation you were sent. You come straight back to it.';
  }
  if (from.startsWith('/table/')) {
    return 'Log in, or sign up if you are new here, to open the table you were sent. You come straight back to it.';
  }
  return null;
}
